/*
=====================================
    Sketch: 3D CANVAS 
=====================================
*/

import {removeClass, isMobile}  from './helper.js';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import {vertexShader, fragmentPlane}  from './shader.js';

export class Sketch {
    constructor(){
        this.el = {
            sidebar: document.getElementsByClassName('sidebar')[0],
            canvas: document.getElementsByClassName('modal__content')[0],
            objectActive: false,
            modal: document.getElementsByClassName('js-modal')[0],
            swipeContainer: document.getElementById('swipe-content-container'),
            zoomIn: document.getElementById('zoomIn'),
            zoomOut: document.getElementById('zoomOut')
        }
        this._dracoLoader = null;
        // Log events flag
        this.logEvents = false;
        // Global vars to cache event state
        this.evCache = new Array();
        this.prevDiff = -1;


        this.setupGlobals();
        this.initScene();
        this.initRotateOnMouse();
        this.initMobileZoom();
        
    }
    setupGlobals(){
        this.scene;
        this.planeScene;
        this.camera;
        this.renderer;
        this.interaction;
        
        this.controls;
        this.dragStart = {x: 0, y: 0};
        
        this.raycaster;
        this.mouse;
        this.eMouse;
        this.elasticMouse;
        this.elasticMouseTemp;
        this.elasticMouseVel;
        this.raycastPlane;
        this.raycastLight;
        
        this.point;
        this.pointHelper;
        
        this.planeMaterial;
        this.textMaterial;

        this.currentObject;
    }

    initScene(){
        this.scene = new THREE.Scene();
        this.planeScene = new THREE.Scene();
        
        this.camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.001, 1000 );
        this.camera.position.set(0, 0.05, 1);

        this.renderer = new THREE.WebGLRenderer();
        
        this.renderer.setSize( window.innerWidth, window.innerHeight );
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setClearColor(0x000000, 1);
        this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.physicallyCorrectLights = true;
        this.renderer.autoClear = false;

        
        this.el.canvas.appendChild( this.renderer.domElement );
    
        // Raycaster Light Effect
        this.raycaster = new THREE.Raycaster();
        this.mouse = new THREE.Vector2(0,0);
        this.eMouse = new THREE.Vector2(0,0);
        this.elasticMouse = new THREE.Vector2(0,0);
        this.elasticMouseTemp = new THREE.Vector2(0,0);
        this.elasticMouseVel = new THREE.Vector2(0,0);
        this.raycast();


        window.addEventListener( 'resize', this.resize.bind(this), false);
        this.updateScene();

    }

    raycast(){
        var that = this;
        const planeUniforms = {
            u_time: { value: 0.0 },
            u_mouse: { value:{ x:0.0, y:0.0 }},
            u_light: { value: new THREE.Vector3(0,0,0) },
            u_resolution: { value:{ x:0, y:0 }}
        }

        this.planeMaterial = new THREE.ShaderMaterial({
            uniforms: planeUniforms,
            vertexShader: vertexShader,
            fragmentShader: fragmentPlane,
        });
        
        this.raycastPlane = new THREE.Mesh(  
            new THREE.PlaneBufferGeometry(10,10),
            that.planeMaterial
        );

        this.planeScene.add( this.raycastPlane );

        this.raycastLight = new THREE.Mesh(  
            new THREE.SphereBufferGeometry(0.01,10,10),
            new THREE.MeshBasicMaterial({
                color: 0x000000,
                opacity: 0,
                transparent: true

            })
        );

        this.scene.add( this.raycastLight );

        
        window.addEventListener('mousemove', function(event){
            
            that.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
            that.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

            that.eMouse.x = event.clientX;
            that.eMouse.y = event.clientY;

            that.raycaster.setFromCamera(that.mouse, that.camera);
            const intersects = that.raycaster.intersectObjects( [that.raycastPlane] );
            if(intersects.length > 0){
                let p = intersects[0].point;
                that.eMouse.x = p.x;
                that.eMouse.y = p.y;
            }

        });

    }

    addObjectToCanvas(items, target){
        // remove object from canvas
        if(this.currentObject){
            this.scene.remove(this.currentObject);
        }
        for (let i = 0; i < items.length; i++) {
            if(items[i].id == target){
                // remove new object
                if(isMobile()){
                    this.loadGltf(items[i].glbmobile.url);
                } else {
                    this.loadGltf(items[i].glb.url);
                }
            }
            
        }
    }

    initRotateOnMouse(){
        const that = this;
        const rotationSpeed = 0.005;

        this.el.swipeContainer.addEventListener('dragStart', function(event){
            that.dragStart.x = event.detail.x;
            that.dragStart.y = event.detail.y;
        });
        this.el.swipeContainer.addEventListener('dragging', function(event){
            
            if(that.dragStart.x > event.detail.x){
                that.currentObject.rotation.y += Math.sign(event.detail.x) * rotationSpeed;
            } else {
                that.currentObject.rotation.y -= Math.sign(event.detail.x) * rotationSpeed;
            }
            if(that.dragStart.y > event.detail.y){
                // that.currentObject.position.y += that.currentObject.rotation.x += Math.sign(event.detail.y) * rotationSpeed;
            } else {
                // that.currentObject.position.y -= Math.sign(event.detail.y) * rotationSpeed;
            }

            that.mouse.x = (event.detail.x / window.innerWidth) * 2 - 1;
            that.mouse.y = -(event.detail.y / window.innerHeight) * 2 + 1;

            that.eMouse.x = event.clientX;
            that.eMouse.y = event.clientY;

            that.raycaster.setFromCamera(that.mouse, that.camera);
            const intersects = that.raycaster.intersectObjects( [that.raycastPlane] );
            if(intersects.length > 0){
                let p = intersects[0].point;
                that.eMouse.x = p.x;
                that.eMouse.y = p.y;
            }
            
        });
        this.el.swipeContainer.addEventListener('wheel', function(event){
            const delta = event.wheelDelta ? event.wheelDelta : event.deltaY * -1;
            if (delta > 0 && that.camera.position.z >= 0.8)  {
                // console.log(that.camera.position.z);
                that.camera.position.z -= 0.005;
            } else if (delta < 0 && that.camera.position.z <= 2) {
                that.camera.position.z += 0.005;

            }
        });

    }

    initMobileZoom(){
        const that = this;
        this.el.zoomIn.addEventListener('click', function(){
            if (that.camera.position.z > 0.8)  {
                that.camera.position.z -= 0.1;
            }
        });
        this.el.zoomOut.addEventListener('click', function(){
            if (that.camera.position.z < 2)  {
                that.camera.position.z += 0.1;
            } 
        });
    }

    loadGltf(model) {

        const that = this;
        const loader = new GLTFLoader();
        
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderConfig({ type: 'js' });
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
        dracoLoader.preload();
        loader.setDRACOLoader( dracoLoader );
        
        loader.load(
            // resource URL
            model,
            // called when the resource is loaded
            function ( gltf ) {

                const vshader = `
                    varying vec2 v_uv;
                    varying vec3 v_position;
                    varying vec3 v_normal;
                    varying vec3 v_worldPosition;
                    void main() {	
                        v_uv = uv;
                        v_position = position;
                        v_worldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
                        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                    }
                `
                const fragment = `
                    #define PI 3.141592653589
                    varying vec2 v_uv;
                    uniform vec3 u_light;
                    varying vec3 v_position;
                    varying vec3 v_worldPosition;
                    varying vec3 v_normal;
                    uniform sampler2D u_text;
                    
                    float getScatter(vec3 cameraPos,vec3 dir,vec3 lightPos, float d){
                        vec3 q = cameraPos - lightPos;
                        float b = dot(dir, q);
                        float c = dot(q, q);
                        float t = c - b*b;
                        float s = 1.0 / sqrt(max(0.0001, t));
                        float l = s * (atan ( (d+b) * s) - atan (b*s));
                        return pow(max(0.0, l / 150.), 0.8 );
                    }

                    void main (void)
                    {
                    
                        vec3 cameraToWorld = v_worldPosition - cameraPosition;
                        vec3 cameraToWorldDirection = normalize(cameraToWorld);
                        float cameraToWorldDistance = length(cameraToWorld);
            
                        vec3 lightToWorld = normalize(u_light - v_worldPosition);
                        float diffusion = max(0., dot(v_normal, lightToWorld));
                                                    
                        float dist = length(u_light - v_position);
                        float scatter = getScatter(cameraPosition, cameraToWorldDirection, u_light, cameraToWorldDistance);
                        
                        vec4 tex = texture2D(u_text, v_uv);

                        // gl_FragColor = vec4(tex.r - dist, tex.g - dist, tex.g - dist, tex.a);
                        // gl_FragColor = vec4(tex.r + scatter, tex.g + scatter, tex.g + scatter, tex.a);
                        gl_FragColor = vec4(tex.r - dist, tex.g - dist, tex.b - dist, tex.a);

                    }
                `;
                
                const uniforms = {
                    u_text: { value: gltf.scene.children[0].material.map },
                    u_time: { value: 0.0 },
                    u_mouse: { value:{ x:0.0, y:0.0 }},
                    u_light: { value: new THREE.Vector3(0,0,0) },
                    u_resolution: { value:{ x:0, y:0 }}
                }
                
                that.textMaterial = new THREE.ShaderMaterial( {
                    uniforms: uniforms,
                    vertexShader: vshader,
                    fragmentShader: fragment
                } );
                
                // Add Material to Mesh
                that.el.objectActive = true;
                gltf.scene.children[0].material = that.textMaterial;
                // Set Global
                that.currentObject = gltf.scene.children[0];
                // Set Position
                that.currentObject.position.set(0, 0, 0.5);
                // Add Mesh to the screne
                that.scene.add( gltf.scene.children[0] );
                // Remove Loader
                removeClass(that.el.modal, 'modal--is-loading');
        
            },
            // called while loading is progressing
            function ( xhr ) {},
            // called when loading has errors
            function ( error ) { console.log( error );}
        );


    }


    updateScene(){

        // Mouse Calculations
        this.elasticMouseTemp.copy(this.eMouse).sub(this.elasticMouse).multiplyScalar(0.1);
        this.elasticMouseVel.add(this.elasticMouseTemp);
        this.elasticMouseVel.multiplyScalar(0.8);
        this.elasticMouse.add(this.elasticMouseVel);

        this.raycastLight.position.x = this.elasticMouse.x;
        this.raycastLight.position.y = this.elasticMouse.y;
        
        // Add Mouse to the Materials
        this.planeMaterial.uniforms.u_light.value = this.raycastLight.position;
        if(this.el.objectActive){
            this.textMaterial.uniforms.u_light.value = this.raycastLight.position;
        }
        
        requestAnimationFrame(() => this.updateScene());
        
        this.renderer.clear();
        this.renderer.render( this.planeScene, this.camera );
        this.renderer.clearDepth();
        this.renderer.render( this.scene, this.camera );
        
        
    }
    resize(){
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize( window.innerWidth, window.innerHeight );
    }
}